//export const SERVER_BASE_URL = "http://api.fibourse.prod-projet.com/";
//export const SERVER_BASE_URL = "https://pp.api-prexange.prexange.com/"
export const SERVER_BASE_URL = "https://api-prexange.prexange.com/";
//export const SERVER_BASE_URL = "http://localhost:8753/";
export const SERVER_BASE_URL_API = SERVER_BASE_URL + "api/";
export const IMAGE_URL = SERVER_BASE_URL + "uploads/images/";

// ************** Dashboard *************************
export const listDocument = SERVER_BASE_URL_API + 'catalogs?page=';
export const favoritesDossier = SERVER_BASE_URL_API + 'favorites/';
export const allQuotes = SERVER_BASE_URL_API + 'getAllQuotes';
// ************** Folders *************************
export const draft = SERVER_BASE_URL_API + 'requests/draft';
export const listByUser = SERVER_BASE_URL_API + 'folders/user/';
export const listInterectDoc = SERVER_BASE_URL_API + 'requests/owner';
// ************** Catalog *************************
export const folderDetails = SERVER_BASE_URL_API + 'catalogs/';
//***************** Source *************************
export const sources = SERVER_BASE_URL_API + 'sources';
//***************** users *************************
export const usersList = SERVER_BASE_URL_API + 'admin/users?page=';
export const usersDetails = SERVER_BASE_URL_API + 'users/';
//***************** Proposales *********************
export const proposals = SERVER_BASE_URL_API + 'proposals';
//***************** My Proposales *********************
export const myProposals = SERVER_BASE_URL_API + 'proposal';
export const proposal = SERVER_BASE_URL_API + 'proposals/folder/';
//***************** Register *********************
export const registerUrl = SERVER_BASE_URL + 'register';
//***************** login *********************
export const login = SERVER_BASE_URL + 'login';
//***************** Update Password *********************
export const updatePassword = SERVER_BASE_URL_API + 'updatePassword/';
//***************** Upload File *********************
export const uploadFile = SERVER_BASE_URL_API + 'files';
//***************** Logout File *********************
export const logout = SERVER_BASE_URL_API + 'logout';
//***************** Logout File *********************
export const resetPassword = SERVER_BASE_URL + 'reset/password';
//***************** Refreche Token *********************
export const refrecheToken = SERVER_BASE_URL + 'token/refresh';
//***************** Rating  *********************
export const rating = SERVER_BASE_URL_API + 'rating';
//***************** Rating  *********************
export const rgpd = SERVER_BASE_URL_API + 'rgpd';


//***************** Agents by bank  *********************
export const agentsByBank = SERVER_BASE_URL_API + 'agents';
//***************** Assignement  *********************
export const assignAgent = SERVER_BASE_URL_API + 'assignFolder';
export const checkAssignement = SERVER_BASE_URL_API + 'check/assignement/';
export const getAssignement = SERVER_BASE_URL_API + 'assignement/';

//***************** History *********************
export const addHistory = SERVER_BASE_URL_API + 'request/history/carcass/';